/* F1B.1 presentation lifecycle only. Native Impulse owns all cart writes. */
(function (root) {
  'use strict';
  if (root.NikuyaCartIntegration) return;
  const doc = root.document;
  const mounts = {
    acquisition: '[data-nikuya-cart-acquisition]',
    recommendations: '[data-nikuya-cart-recommendations]'
  };
  let controller, provider, prepurchaseProvider, enabled = false, generation = 0;
  let prepurchaseGeneration = 0, expiryTimer;
  const pdpMount = '[data-nikuya-pdp-acquisition]', stickyMount = '[data-nikuya-cart-sticky]';
  const media = root.matchMedia('(max-width: 768px)');
  const gates = () => Object.freeze({
    presentationEnabled: enabled,
    financialEnforcementVerified: false,
    casePricingVerified: false,
    caseReconciliationEnabled: false
  });
  function put(selector, html) {
    doc.querySelectorAll(selector).forEach(node => {
      node.innerHTML = html;
      node.hidden = !html;
    });
  }
  function clear() { root.NikuyaCartBranded?.clear(); Object.values(mounts).forEach(selector => put(selector, '')); }
  function invalidate() { generation += 1; clear(); }
  async function refresh(event) {
    const revision = ++generation;
    clear();
    if (!enabled || !provider || !root.NikuyaCartUIPresenter) return;
    try {
      const form = event?.detail?.form || doc.querySelector('#CartDrawer-Form');
      const items = form?.querySelector('[data-products] .cart__items');
      const itemCount = Number(form?.dataset.nikuyaCartCount || items?.dataset.count || 0);
      // Only an approved future context provider can supply a resolved presentation model.
      // URL selectors, historical fixtures and readiness booleans are not entry provenance.
      const model = await provider({ form, itemCount, reason: event?.type || 'init' });
      if (!enabled || revision !== generation || !model) return;
      const presenter = root.NikuyaCartUIPresenter;
      root.NikuyaCartBranded?.apply(form, model);
      if (itemCount > 0) put(mounts.acquisition, presenter.badge(model.acquisition));
      // No verified DollarLabs enforcement exists in F1B.1: promotional recommendation
      // prices, gift presentation and custom financial summary deliberately stay absent.
    } catch (_) {
      if (revision === generation) clear();
    }
  }
  function clearPrepurchase() {
    root.clearTimeout(expiryTimer);
    put(pdpMount, '');
    put(stickyMount, '');
  }
  async function refreshPrepurchase() {
    const revision = ++prepurchaseGeneration;
    clearPrepurchase();
    if (!enabled || !prepurchaseProvider || !root.NikuyaCartUIPresenter) return;
    const mount = doc.querySelector(pdpMount);
    if (!mount) return;
    const selected = doc.getElementById(mount.dataset.formId)?.querySelector('[name="id"]')?.value;
    if (String(selected) !== mount.dataset.variantId) return;
    try {
      const model = await prepurchaseProvider({product_id:mount.dataset.productId,variant_id:selected,sku:mount.dataset.sku});
      if (!enabled || revision !== prepurchaseGeneration || !model) return;
      const remaining = model.expiresAt - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) return;
      put(pdpMount, root.NikuyaCartUIPresenter.badge(model));
      put(stickyMount, root.NikuyaCartUIPresenter.sticky(model, {}, media.matches));
      expiryTimer = root.setTimeout(() => { ++prepurchaseGeneration; clearPrepurchase(); }, remaining);
    } catch (_) {
      if (revision === prepurchaseGeneration) clearPrepurchase();
    }
  }
  function configure(options = {}) {
    controller?.abort();
    enabled = options.presentationEnabled === true;
    provider = typeof options.presentationProvider === 'function' ? options.presentationProvider : null;
    prepurchaseProvider = typeof options.prepurchaseProvider === 'function' ? options.prepurchaseProvider : null;
    ++prepurchaseGeneration;
    clearPrepurchase();
    invalidate();
    if (!enabled) return gates();
    controller = new AbortController();
    const signal = controller.signal;
    ['nikuya:cart:rendered', 'shopify:section:load', 'pageshow'].forEach(type => {
      (type === 'pageshow' ? root : doc).addEventListener(type, refresh, { signal });
    });
    ['cart:build', 'cart:updated', 'ajaxProduct:added', 'ajaxProduct:error',
      'cart:quantity.cart-cart-drawer', 'cart:quantity.cart-cart', 'shopify:section:unload'].forEach(type => {
      doc.addEventListener(type, invalidate, { signal });
    });
    ['shopify:section:load', 'variant:change'].forEach(type => doc.addEventListener(type, refreshPrepurchase, { signal }));
    ['pageshow', 'focus'].forEach(type => root.addEventListener(type, refreshPrepurchase, { signal }));
    doc.addEventListener('visibilitychange', refreshPrepurchase, { signal });
    doc.addEventListener('shopify:section:unload', () => { ++prepurchaseGeneration; clearPrepurchase(); }, { signal });
    media.addEventListener('change', refreshPrepurchase, { signal });
    refreshPrepurchase();
    refresh();
    return gates();
  }
  root.NikuyaCartIntegration = Object.freeze({ configure, refresh, refreshPrepurchase, gates });
  configure(root.NikuyaCartPresentationConfig);
})(window);
